import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';

import { authGuard } from './guards';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginPage.vue'),
    meta: { title: '登录', requiresAuth: false },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/RegisterPage.vue'),
    meta: { title: '注册', requiresAuth: false },
  },
  {
    path: '/qr-login',
    name: 'QrCodeLogin',
    component: () => import('@/views/auth/QrCodeLogin.vue'),
    meta: { title: '扫码登录', requiresAuth: false },
  },
  {
    path: '/merchant/onboard',
    name: 'MerchantOnboard',
    component: () => import('@/views/merchant/MerchantOnboard.vue'),
    meta: { title: '商家入驻', requiresAuth: false },
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('@/views/main/MainLayout.vue'),
    redirect: '/main/chat',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/im/ChatView.vue'),
        meta: { title: '聊天' },
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/views/main/ContactList.vue'),
        meta: { title: '通讯录' },
      },
      {
        path: 'contact-detail/:userId',
        name: 'ContactDetail',
        component: () => import('@/views/contact/ContactDetail.vue'),
        meta: { title: '联系人详情' },
      },
      {
        path: 'add-contact',
        name: 'AddContact',
        component: () => import('@/views/contact/AddContact.vue'),
        meta: { title: '添加好友' },
      },
      {
        path: 'goods',
        name: 'GoodsSquare',
        component: () => import('@/views/goods/GoodsSquare.vue'),
        meta: { title: '货源广场' },
      },
      {
        path: 'order',
        name: 'OrderList',
        component: () => import('@/views/order/OrderList.vue'),
        meta: { title: '订单' },
      },
      {
        path: 'order/refund-apply/:orderId',
        name: 'RefundApply',
        component: () => import('@/views/order/RefundApply.vue'),
        meta: { title: '申请退款' },
      },
      {
        path: 'order/refund-progress/:orderId',
        name: 'RefundProgress',
        component: () => import('@/views/order/RefundProgress.vue'),
        meta: { title: '退款进度' },
      },
      {
        path: 'order/dispute-apply/:orderId',
        name: 'DisputeApply',
        component: () => import('@/views/order/DisputeApply.vue'),
        meta: { title: '申请争议' },
      },
      {
        path: 'order/dispute-detail/:orderId',
        name: 'DisputeDetail',
        component: () => import('@/views/order/DisputeDetail.vue'),
        meta: { title: '争议详情' },
      },
      {
        path: 'wallet',
        name: 'WalletHome',
        component: () => import('@/views/main/Wallet.vue'),
        meta: { title: '钱包' },
      },
      {
        path: 'bank-cards',
        name: 'BankCards',
        component: () => import('@/views/main/BankCards.vue'),
        meta: { title: '银行卡管理' },
      },
      {
        path: 'moment',
        name: 'MomentFeed',
        component: () => import('@/views/moment/MomentFeed.vue'),
        meta: { title: '朋友圈' },
      },
      {
        path: 'profile',
        name: 'ProfileCenter',
        component: () => import('@/views/profile/ProfileCenter.vue'),
        meta: { title: '个人中心' },
      },
      {
        path: 'profile/edit',
        name: 'ProfileEdit',
        component: () => import('@/views/profile/ProfileEdit.vue'),
        meta: { title: '编辑资料' },
      },
      {
        path: 'profile/qrcode',
        name: 'MyQrCode',
        component: () => import('@/views/profile/MyQrCode.vue'),
        meta: { title: '我的二维码' },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/Settings.vue'),
        meta: { title: '设置' },
        children: [
          {
            path: 'security',
            name: 'AccountSecurity',
            component: () => import('@/views/settings/AccountSecurity.vue'),
            meta: { title: '账号安全' },
          },
          {
            path: 'notification',
            name: 'NotificationSettings',
            component: () => import('@/views/settings/NotificationSettings.vue'),
            meta: { title: '通知设置' },
          },
          {
            path: 'privacy',
            name: 'PrivacySettings',
            component: () => import('@/views/settings/PrivacySettings.vue'),
            meta: { title: '隐私设置' },
          },
          {
            path: 'about',
            name: 'AboutPage',
            component: () => import('@/views/settings/AboutPage.vue'),
            meta: { title: '关于' },
          },
        ],
      },
      {
        path: 'search',
        name: 'GlobalSearch',
        component: () => import('@/views/search/GlobalSearch.vue'),
        meta: { title: '搜一搜' },
      },
      {
        path: 'scanner',
        name: 'ScannerPage',
        component: () => import('@/views/scanner/ScannerPage.vue'),
        meta: { title: '扫一扫' },
      },
      {
        path: 'file-assistant',
        name: 'FileAssistant',
        component: () => import('@/views/file/FileAssistant.vue'),
        meta: { title: '文件助手' },
      },
      {
        path: 'draft-box',
        name: 'DraftBox',
        component: () => import('@/views/draft/DraftBox.vue'),
        meta: { title: '草稿箱' },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局路由守卫
router.beforeEach(authGuard);

export default router;
